module.exports = __webpack_public_path__ + "img/pro-xtIcon9.49403f5d.png";